"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BARE_WORKOUT = void 0;
const __1 = require("..");
exports.BARE_WORKOUT = {
    workoutType: __1.WorkoutType.normal,
    exercises: [],
    createdAt: new Date(),
    createdBy: 'TLM',
    generatedBy: 'trainer',
    duration: 20 * 60 * 1000,
    favorite: false,
    internalNotes: '',
    clientNotes: '',
    progress: {
        status: __1.WorkoutStatus.notStarted,
        exerciseIndex: 0,
        playbackTime: 0
    }
};
//# sourceMappingURL=workoutModel.js.map